<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useDocFeedback } from '@/composables/useDocFeedback'

const props = defineProps<{
  category: string
  slug: string
  locale: string
}>()

const { t } = useI18n()
const { submit, submitting, submitted, error } = useDocFeedback()

async function vote(helpful: boolean): Promise<void> {
  await submit(props.category, props.slug, helpful)
}
</script>

<template>
  <div
    class="mt-8 pt-6 border-t border-slate-700/50"
    aria-live="polite"
  >
    <!-- Question -->
    <div
      v-if="!submitted"
      class="flex flex-col sm:flex-row sm:items-center gap-3"
    >
      <p class="text-sm text-slate-400">
        {{ t('docs.feedback.question') }}
      </p>
      <div class="flex items-center gap-2">
        <button
          type="button"
          :disabled="submitting"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 text-sm text-slate-300 hover:text-white hover:border-emerald-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          :aria-label="t('docs.feedback.yes')"
          @click="vote(true)"
        >
          <span aria-hidden="true">👍</span>
          <span>{{ t('docs.feedback.yes') }}</span>
        </button>
        <button
          type="button"
          :disabled="submitting"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 text-sm text-slate-300 hover:text-white hover:border-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          :aria-label="t('docs.feedback.no')"
          @click="vote(false)"
        >
          <span aria-hidden="true">👎</span>
          <span>{{ t('docs.feedback.no') }}</span>
        </button>
      </div>
    </div>

    <!-- Success -->
    <p
      v-else-if="!error"
      class="text-sm text-emerald-400"
    >
      {{ t('docs.feedback.thanks') }}
    </p>

    <!-- Error (inline retry) -->
    <div
      v-if="error"
      class="flex items-center gap-3"
    >
      <p class="text-sm text-red-400">
        {{ t('docs.feedback.error') }}
      </p>
    </div>
  </div>
</template>
